import { createSlice } from "@reduxjs/toolkit";

export const loansTimeSlice = createSlice({
  name: "loansTime",
  initialState: {
    timeCount: 0,
  },
  reducers: {
    addTime: (state, action) => {
      state.timeCount += action.payload;
    },
    resetTime: (state) => {
      state.timeCount = 0;
    },
  },
});

export const { addTime, resetTime } = loansTimeSlice.actions;

export default loansTimeSlice.reducer;
